<template>
  <div class="admin-menu">
    <MenuBaseComponent :menu-properties="menuProperties" />
  </div>
</template>

<script>
import MenuBaseComponent from "@/components/navigation/menu/utils/MenuBaseComponent";
import {
  userDetailsAdmin, depsFunctionalities, gesFunctionalities, meFunctionalities,
  changeTable, validateAnnouncementsDeps, validateAnnouncementsMe, diavImport, allAdmins,activeReserve,kanonismoi
} from "@/config/menuopts"
export default {
  name: "SuperAdminMenu",
  components: {MenuBaseComponent},
  data() {
    return {
      menuProperties: {
        userDetailsAdmin,
        allAdmins,
        gesFunctionalities,
        depsFunctionalities,
        meFunctionalities,
        changeTable,
        validateAnnouncementsDeps,
        validateAnnouncementsMe,
        activeReserve,
        diavImport,
        kanonismoi
      },
    }
  },
}
</script>

<style scoped>

</style>